<template lang="pug">
	.modal(v-bind:class="modalClass")
		.modal-background
		.modal-card
			header.modal-card-head(v-if="title")
				p.modal-card-title.is-unselectable {{ title }}
				button.button.delete(aria-label="close" @click="close")
					x-icon
			section.modal-card-body
				slot
		button.modal-close.is-large(aria-label="close" @click="close" v-if="!title")
</template>

<script>
import { XIcon } from 'vue-feather-icons'

export default {
	components: {
		XIcon
	},
	data() {
		return {
			active: false
		}
	},
	props: {
		title: {
			type: String,
			required: false
		}
	},
	computed: {
		modalClass() {
			return { 'is-active': this.active }
		}
	},
	methods: {
		open() {
			this.active = true
			document.documentElement.classList.add('is-clipped')
		},
		close() {
			this.active = false
			document.documentElement.classList.remove('is-clipped')
			this.$emit('close')
		}
	}
}
</script>
